import { GraduationCapIcon, HandshakeIcon, HeartHandshakeIcon, ScaleIcon, TrendingUpIcon, WalletIcon } from "lucide-react";

export const careerCommitments = [
  { en: "We proudly support immigrants by providing job opportunities, training, and resources to succeed.", es: "Apoyamos con orgullo a los inmigrantes con oportunidades de empleo, capacitación y recursos para triunfar." },
  { en: "We hire all immigrants legally authorized to work.", es: "Contratamos a todos los inmigrantes autorizados legalmente para trabajar." },
  { en: "On-the-job training and development.", es: "Capacitación y desarrollo en el trabajo." },
  { en: "A supportive and respectful environment.", es: "Un ambiente de apoyo y respeto." },
  { en: "Opportunities to grow and advance.", es: "Oportunidades para crecer y avanzar." },
];

export const careerBenefits = [
  { icon: WalletIcon, label: { en: "Fair Wages", es: "Salarios Justos" } },
  { icon: GraduationCapIcon, label: { en: "Training & Development", es: "Capacitación y Desarrollo" } },
  { icon: TrendingUpIcon, label: { en: "Growth Opportunities", es: "Oportunidades de Crecimiento" } },
  { icon: HandshakeIcon, label: { en: "Respectful Workplace", es: "Ambiente Respetuoso" } },
  { icon: ScaleIcon, label: { en: "Equal Respect", es: "Respeto Igual" } },
  { icon: HeartHandshakeIcon, label: { en: "Community Support", es: "Apoyo Comunitario" } },
];

export const applicationSteps = [
  { en: "Submit Application", es: "Envíe su Solicitud" },
  { en: "Phone Interview", es: "Entrevista Telefónica" },
  { en: "In-Person Meeting", es: "Reunión en Persona" },
  { en: "Start Your Journey", es: "Comience su Camino" },
];

export const teamFlags = [
  { code: "mx", name: { en: "Mexico", es: "México" } },
  { code: "ht", name: { en: "Haiti", es: "Haití" } },
  { code: "gt", name: { en: "Guatemala", es: "Guatemala" } },
  { code: "sv", name: { en: "El Salvador", es: "El Salvador" } },
  { code: "hn", name: { en: "Honduras", es: "Honduras" } },
];

export const careersImage = "https://cdn.magicpatterns.com/patterns/generated-images/41cacef9-58bb-444a-acb2-e60801a18525.jpg";
